import { useQuery } from '@tanstack/react-query';

import { getDefaultPaymentProvider } from 'services/PaymentProviderService/PaymentProviderService';

/**
 * Custom hook to fetch the default payment provider using React Query.
 *
 * @param params - The hook parameters.
 * @returns The result object from the useQuery hook.
 */
export const useDefaultPaymentProvider = ({ onError, onSuccess }) =>
  useQuery(['defaultPaymentProvider'], () => getDefaultPaymentProvider(), {
    onError,
    onSuccess,
    refetchOnWindowFocus: false,
  });
